import * as Api from '@ViewModels';
import { computed, observable, makeObservable } from 'mobx';
import { ILeadSearchView, IPhoneCallLogView } from './leads/interfaces';

/**
 * The view models in this file are just skins over the interfaces. They are used for various views like the Call Log
 * screen, Follow Ups, etc.
 */

export class RecentCallViewModel extends Api.ViewModel {
	public phoneCallView: IPhoneCallLogView;
	constructor(userSession: Api.UserSessionContext, view: IPhoneCallLogView) {
		super(userSession);

		makeObservable(this, {
			phoneCallView: observable,
			phoneCall: computed,
			company: computed,
			id: computed,
		});

		this.phoneCallView = view;
	}

	get phoneCall() {
		return this.phoneCallView.phoneCall;
	}

	get company() {
		return this.phoneCallView.company;
	}

	public get id() {
		return this.phoneCallView.phoneCall.id;
	}
}

export class FollowUpViewModel extends Api.ViewModel {
	public followUp: ILeadSearchView;
	constructor(userSession: Api.UserSessionContext, view: IPhoneCallLogView) {
		super(userSession);

		makeObservable(this, {
			followUp: observable,
			followUpDate: computed,
			id: computed,
		});

		this.followUp = view;
	}

	get followUpDate() {
		return this.followUp.followUp.followUpDate;
	}

	public get id() {
		return this.followUp.company.id;
	}
}

export class FollowUpsViewModel extends Api.ViewModel {
	public followUps: Api.BaseObservablePageCollectionController<ILeadSearchView, FollowUpViewModel>;
	constructor(userSession: Api.UserSessionContext) {
		super(userSession);

		makeObservable(this, {
			followUps: observable,
			controller: computed,
		});

		this.followUps = new Api.BaseObservablePageCollectionController<ILeadSearchView, FollowUpViewModel>({
			apiPath: this.composeApiUrl({ urlPath: 'lead/followUps' }),
			client: this.userSession.webServiceHelper,
			httpMethod: 'GET',
			transformer: x => new FollowUpViewModel(this.userSession, x),
		});
	}

	get controller() {
		return this.followUps;
	}
}
